import React from 'react'

import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

type Props = {
  countryVat: number
  isLocalVatIncluded?: boolean
}

export const VatDisclaimer = ({countryVat, isLocalVatIncluded}: Props) => {
  if (countryVat && isLocalVatIncluded) {
    return (
      <Text variant="bodyS" tag="div">
        <FormattedMessageWrapper
          id="residentVat.residentIsraeliVatIncluded"
          defaultMessage="The total price includes {vat}% VAT for Israeli residents (to be paid at the property). If you're not a resident, you're exempt from this payment. Residency status will be verified by the property at check-in."
          values={{
            vat: countryVat
          }}
        />
      </Text>
    )
  }

  return (
    <Text variant="bodyS" tag="div">
      <FormattedMessageWrapper
        id="residentVat.residentIsraeliVatNotIncluded"
        defaultMessage="Total price shown includes 0% VAT. If you are a resident, you’ll be charged an additional {vat}% VAT at the property. Residency status will be verified by the property at check-in. "
        values={{
          vat: countryVat
        }}
      />
    </Text>
  )
}
